
export const PaymentGateway = Object.freeze({ 1: "به پرداخت ملت", 2: "پارسیان", 7: "فناوا" });

export const PaymentType = Object.freeze({
  1: { icon: "CreditCardIcon", title: "کارت به کارت" },
  2: { icon: "FileTextIcon", title: "قبض" },
  6: { icon: "CPUIcon", title: "QR" },
  7: { icon: "CastIcon", title: "NFC" },
  9: { icon: "AwardIcon", title: "اعتبارسنجی" },
  10: { icon: "WifiIcon", title: "شارژ اینترنت" },
  11: { icon: "SmartphoneIcon", title: "شارژ سیمکارت" },
  12: { icon: "HomeIcon", title: "پرداخت سازمانی" },
  13: { icon: "ChromeIcon", title: "درگاه پرداخت" },
  14: { icon: "SmartphoneIcon", title: "شارژ سیمکارت" },
  15: { icon: "WifiIcon", title: "شارژ اینترنت" },
});

export const BillState = Object.freeze({
  0: { icon: "ClockIcon", title: "در انتظار پرداخت", color: "warning" },
  1: { icon: "CheckCircleIcon", title: "پرداخت شده", color: "success" },
  2: { icon: "XCircleIcon", title: "رد شده", color: "danger" }
});

export const TransactionState = Object.freeze({
  0: { icon: "ClockIcon", title: "در انتظار پرداخت", color: "warning" },
  1: { icon: "CheckCircleIcon", title: "موفق", color: "success" },
  2: { icon: "XCircleIcon", title: "رد شده", color: "danger" },
  3: { icon: "SlashIcon", title: "ناموفق", color: "danger" },
});

export const DraftStep = Object.freeze({
  1: { value: 1, name: 'Psp', color: "", title: "PSP", description: "" },
  13: { value: 13, name: 'Shop', color: "", title: "فروشگاه", description: "" },
  5: { value: 5, name: 'Terminal', color: "", title: "ترمینال", description: "" },
  6: { value: 6, name: 'EditIban', color: "", title: "ویرایش شبا", description: "" },
  7: { value: 7, name: 'DisableTerminal', color: "", title: "غیرفعال", description: "" },
  14: { value: 14, name: 'EditInformation', color: "", title: "ویرایش", description: "" },
  17: { value: 17, name: 'ChangeShopAddress', color: "", title: "ویرایش آدرس", description: "" },
  18: { value: 18, name: 'EnableTerminal', color: "", title: "فعال کردن ", description: "" },
});
export const DraftState = Object.freeze({
  0: { value: 0, name: 'InRequest', color: "", title: "درحال تکمیل", description: "" },
  1: { value: 1, name: 'Request', color: "", title: "درخواست", description: "" },
  2: { value: 2, name: 'InComplete', color: "", title: "ناقص", description: "" },
  3: { value: 3, name: 'Complete', color: "", title: "کامل", description: "" },
  8: { value: 8, name: 'Waiting', color: "", title: "انتظار", description: "" },
  12: { value: 12, name: 'Delay', color: "", title: "تاخیر", description: "" },
  5: { value: 5, name: 'Rejected', color: "", title: "رد شده", description: "" },
  14: { value: 14, name: 'Approved', color: "", title: "موفق", description: "" },
  500: { value: 500, name: 'Error', color: "", title: "خطا", description: "" },
});
export const DraftType = Object.freeze({
  0: { value: 0, name: 'NewSmsGateway', icon: "ShoppingCartIcon", title: "اولین درگاه پیامکی", color: "success" },
  1: { value: 1, name: 'NewWebGateWay', icon: "GlobeIcon", title: "اولین درگاه وب", color: "success" },
  2: { value: 2, name: 'Edit', icon: "EditIcon", title: "ویرایش", description: "color" },
  10: { value: 10, name: 'SucceedingSmsGateway', icon: "ShoppingCartIcon", title: "درگاه پیامکی", color: "dark", succeeding:"true" },
  11: { value: 11, name: 'SucceedingWebGateWay', icon: "GlobeIcon", title: "درگاه وب", color: "dark", succeeding:"true" },
});


export const MerchantStatus = Object.freeze({
  1: { name: 'Active', icon: "CheckCircleIcon", title: "فعال", description: "", minTitle: 'فعال', color: "success" },
  '-16': { name: 'CollectedShaparak', icon: "XCircleIcon", title: "جمع‌شده(شاپرک)", description: "", minTitle: 'جمع‌شده', color: "danger" },
  '-15': { name: 'CollectedProviderRequested', icon: "XCircleIcon", title: "جمع‌شده(به درخواست سرویس دهنده)", description: "", minTitle: 'جمع‌شده', color: "danger" },
  '-14': { name: 'CollectedCustomerRequested', icon: "XCircleIcon", title: "جمع‌شده(به درخواست مشتری)", description: "", minTitle: 'جمع‌شده', color: "danger" },
  '-13': { name: 'DeactiveTemporarilyShaparak', icon: "AlertTriangleIcon", title: "غیرفعال(شاپرک)", description: "", minTitle: 'غیرفعال', color: "danger" },
  '-12': { name: 'DeactiveTemporarilyProviderRequested', icon: "AlertTriangleIcon", title: "غیرفعال(به درخواست سرویس دهنده)", description: "", minTitle: 'غیرفعال', color: "danger" },
  '-11': { name: 'DeactiveTemporarilyCustomerRequested', icon: "AlertTriangleIcon", title: "غیرفعال(به درخواست مشتری)", description: "", minTitle: 'غیرفعال', color: "danger" },
  '-1': { name: 'Deactive', icon: "AlertCircleIcon", title: "غیرفعال", description: "", minTitle: 'غیرفعال', color: "primary" },
  '-10': { name: 'InternalDeactive', icon: "AlertCircleIcon", title: "غیرفعال موقت", description: "", minTitle: 'غیرفعال', color: "primary" },

});

export const BusinessType = Object.freeze({
  Virtual: { value: 2, icon: "CPUIcon", title: "مجازی" },
  Physical: { value: 0, icon: "CPUIcon", title: "فیزیکی" },
  Combined: { value: 1, icon: "CPUIcon", title: "ترکیبی" },
});

export const CreateEditMode = Object.freeze({
  Create: 0, Edit: 1, View: -1
});

export const BirthCrtfctSeriesLetter = Object.freeze([
  { value: 0, text: 'الف' },
  { value: 1, text: 'ب' },
  { value: 2, text: 'ل' },
  { value: 3, text: 'د' },
  { value: 4, text: 'ر' },
  { value: 5, text: 'یک' },
  { value: 6, text: 'دو' },
  { value: 7, text: 'سه' },
  { value: 8, text: 'چهار' },
  { value: 9, text: 'نه' },
  { value: 10, text: 'ده' },
  { value: 11, text: 'یازده' },
  { value: 12, text: 'ش' },
]);

export const RequestRejectionReason = Object.freeze(
  {
    '-1': 'UNDEFINED',
    '5': 'MANDATORY_FIELD',
    '6': 'FORMAT_FIELD',
    '11': 'DUPLICATE_RECOR',
    '12': 'INVALID_IDENTIFICATION_DATA',
    '13': 'SYSTEM_EXCEPTION',
    '15': 'NO_IBANS',
    '16': 'MASTER_DETAIL_RELATION',
    '17': 'BAD_DATA',
    '18': 'CHILD_RECORD_FOUND',
    '25': 'ERROR_APPLY_SWITCH_RESULT',
    '29': 'BAD_AGE_RANGE',
    '30': 'THE_PERSON_IS_DECEASED',
    '31': 'SEND_SMS_FAILURE',
    '35': 'INVALID_CERTIFICATE_ISSUE_DATE',
    '36': 'DUPLICATE_RECORD_NATIONAL_CODE',
    '37': 'LIMITATION_MERCHANT',
    '39': 'INVALID_POSTAL_CODE',
    '40': 'UNABLE_TO_ENQUIRE_IBAN_INFO',
    '41': 'INVALID_IBAN',
    '43': 'LENGTH_FIELD',
    '44': 'OLD_SYSTEM_DATA_EXISTS',
    '46': 'DUPLICATE_FIELD',
    '47': 'INVALID_TERMINAL_TYPE_FOR_BUSINESS_TYPE',
    '48': 'UNKNOWN_IBAN_BANK',
    '49': 'MERCHANT_NOT_EXISTS',
    '51': 'INVALID_IBAN_ACCEPTOR',
    '52': 'DATA_NOT_EXISTS',
    '54': 'UNCHANGED_DATA',
    '55': 'DUPLICATE_OLD_ACCEPTOR',
    '56': 'INVALID_REQUEST',
    '57': 'DUPLICATE_REQUEST_FOR_ACCEPTOR',
    '58': 'BAD_DATA_RANGE',
    '59': 'INVALID_SHOP_FOR_ACCEPTOR',
    '60': 'INVALID_DATA_TYPE',
    '61': 'INCONSISTENT_DATA',
    '62': 'INVALID_PROVINCE_FOR_POSTAL_CODE',
    '63': 'INVALID_CITY_FOR_POSTAL_CODE',
    '64': 'PARTIAL_DATA',
    '65': 'UNCHANGED_IBAN',
    '66': 'SWITCH_CHANGE_ERROR',
    '67': 'SHAPARAK_ADMINISTRATION_REJECTION',
    '68': 'UNABLE_TO_ACTIVATE_PERMANENTLY_DEACTIVATED_TERM',
    '69': 'UNABLE_TO_MIGRATE_PERMANENTLY_DEACTIVATED_ACCEP',
    '70': 'ITEM_COUNT_LIMIT_REACHED',
    '1002': 'BLACKLISTED_MERCHANT',
    '10000': 'DUPLICATE_REQUEST_FOR_TERMINAL',
    '10001': 'REQUEST_INVALID_FOR_RESPONSE',
    '10002': 'REQUEST_NOTFOUND_FOR_RESPONSE',
    '10003': 'DUPLICATE_TERMINAL',
    '10004': 'NO_TERMINALS',
    '10008': 'ADMIN_REQUEST_REJECTION'
  }
);

export const CommissionType = Object.freeze(
  {
    1: { value: "Fixed", title: "ثابت" },
    2: { value: "Percent", title: "درصدی" },
    3: { value: "Tiered", title: "پلکانی" },
  }
);
export const TicketPriority = Object.freeze(
  {
    0: { value: "0", title: "کم" },
    1: { value: "1", title: "متوسط" },
    2: { value: "2", title: "زیاد" },
  }
);
export const AttachmentType = Object.freeze(
  {
    NationalCard: { value: "0", title: "کارت ملی", name: "NationalCard" },
    PersonalCertificate: { value: "1", title: "شناسنامه", name: "PersonalCertificate" },
    BusinessCertificate: { value: "2", title: "جواز کسب", name: "BusinessCertificate" },
  }
);

export const Colors = Object.freeze(
  ["primary", "success", "danger", "warning", "dark"]
);

export const EditIbanType = Object.freeze(
  {
    0: { value: "0", title: "جدیدپیشفرض" },
    1: { value: "1", title: "بدون تغییر" },
    2: { value: "2", title: "جدید" },
    3: { value: "3", title: "حذف" },
  }
);

export const MerchantType = Object.freeze({
  0: { name: "Default", icon: "ShoppingCartIcon", title: "پیامکی" },
  1: { name: "Gateway", icon: "GlobeIcon", title: "درگاه" },
});


export const CustomSettingName = Object.freeze({
  1: { icon: "CreditCardIcon", name: "AccountCustomMessage", title: "قالب پیامک قبض", type: String },
  2: { icon: "FileTextIcon", name: "DontSendOwnerMessage", title: "عدم ارسال پیامک پرداخت به پذیرنده", type: Boolean },
  3: { icon: "CPUIcon", name: "SmsReceiverMessage", title: "متن پیامک دریافت کننده", type: String },
});